export default "__VITE_ASSET__ff6106a6__"